import { currentCompany } from '../../actionTypes';

const initialState = {
  loading: true,
  saving: false,
  success: false,
  error: false,
  questions: [],
  answers: [],
};

export default function contractorWorkingHoursAnswers(state = initialState, action) {
  switch (action.type) {
    case currentCompany.contractorWorkingHoursAnswers.get.start:
      return initialState;

    case currentCompany.contractorWorkingHoursAnswers.get.end:
      return {
        ...state,
        loading: false,
        questions: action.payload.questions,
        answers: action.payload.answers,
      };

    case currentCompany.contractorWorkingHoursAnswers.get.error:
      return {
        ...state,
        loading: false,
        error: true,
        questions: [],
        answers: [],
      };

    case currentCompany.contractorWorkingHoursAnswers.create.start:
      return {
        ...state,
        saving: true,
        success: false,
        error: false,
      };

    case currentCompany.contractorWorkingHoursAnswers.create.end:
      return {
        ...state,
        saving: false,
        success: true,
        answers: action.payload.answers,
      };

    case currentCompany.contractorWorkingHoursAnswers.create.error:
      return {
        ...state,
        saving: false,
        error: true,
      };

    default:
      return state;
  }
}
